import { LeftOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { useLeadCardPageBackNavigation } from '../hooks';

import type { FC } from 'react';

import './LeadCardPageBackButton.scss';

interface LeadCardPageBackButtonProps {
  onBack?: () => void;
}

export const LeadCardPageBackButton: FC<LeadCardPageBackButtonProps> = ({
  onBack,
}) => {
  const { goBack } = useLeadCardPageBackNavigation();

  return (
    <Tooltip title="Вернуться назад">
      <Button
        className="LeadCardPageBackButton"
        aria-label="Вернуться назад"
        htmlType="button"
        icon={<LeftOutlined />}
        onClick={onBack ?? goBack}
      />
    </Tooltip>
  );
};
